/**
 * API Configuration
 * Centralized configuration for API client
 */

export const apiConfig = {
  /** Base URL for API requests (empty - endpoints use root routes) */
  baseURL: '',

  /** Request timeout in milliseconds */
  timeout: 300000, // 5 minutes
};
